import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";
import { initAnalytics, capturePageview } from "@/lib/analytics";
import { initErrorTracking, Sentry } from "@/lib/sentry";

initErrorTracking(); // keep early — catches boot-time errors

// Defer product analytics off the critical path: PostHog init runs after first
// paint so it doesn't add to the hydration long task / LCP. Fire the initial
// pageview right after init, since the mount-time one no-ops before init.
const _bootAnalytics = () => {
  initAnalytics();
  capturePageview(window.location.pathname);
};
if (typeof window !== "undefined" && "requestIdleCallback" in window) {
  window.requestIdleCallback(_bootAnalytics, { timeout: 3000 });
} else if (typeof window !== "undefined") {
  setTimeout(_bootAnalytics, 1200);
}

const rootElement = document.getElementById("root");

const Fallback = () => (
  <div
    style={{
      minHeight: "60vh",
      display: "grid",
      placeItems: "center",
      padding: 24,
      textAlign: "center",
    }}
  >
    <div>
      <h1 style={{ fontSize: 20, fontWeight: 700, marginBottom: 8 }}>Something went wrong</h1>
      <p style={{ marginBottom: 16, color: "#64748b" }}>
        Please refresh the page. We've been notified.
      </p>
      <button
        onClick={() => window.location.reload()}
        style={{ padding: "8px 16px", fontWeight: 600 }}
      >
        Reload
      </button>
    </div>
  </div>
);

const tree = (
  <React.StrictMode>
    <HelmetProvider>
      <Sentry.ErrorBoundary fallback={<Fallback />}>
        <App />
      </Sentry.ErrorBoundary>
    </HelmetProvider>
  </React.StrictMode>
);

// react-snap prerenders static HTML at build time; hydrate it on load,
// otherwise mount fresh.
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, tree);
} else {
  ReactDOM.createRoot(rootElement).render(tree);
}
